import { useState, useEffect, useContext } from 'react'
import { FiHome, FiPlus, FiSearch, FiEdit2, FiUserPlus } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { AuthContext } from '../../contexts/auth'

import { Content } from './styles'

export function SignUpCollaborator() {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')

  const { signUpCollaboratorUser, loadingAuth } = useContext(AuthContext)

  async function handleSignUp(e) {
    e.preventDefault()

    if (email !== '' || name !== '' || password !== '') {
      await signUpCollaboratorUser(name, email, password)
      setName('')
      setEmail('')
      setPassword('')
    } else {
      toast.info("Preencha todos os campos corretamente")
    }
  }

  return (
    <>
      <Header />
      <Content>
        <Title name="Cadastrar Colaborador">
          <FiUserPlus size={25} />
        </Title>

        <div className='container'>
          <form onSubmit={handleSignUp}>
            <label>Nome</label>
            <input placeholder='seu nome' value={name} onChange={(e) => setName(e.target.value)} />
            <label>Email</label>
            <input placeholder='seu email' value={email} onChange={(e) => setEmail(e.target.value)} />
            <label>Senha</label>
            <input placeholder='sua senha' value={password} onChange={(e) => setPassword(e.target.value)} />
            <button type='submit' >
              {loadingAuth ? "Carregando..." : "Cadastrar"}
            </button>
          </form>
        </div>


      </Content>
    </>


    // <Container>
    //   <div className='box1'>
    //     <div className='box-description'>
    //       <h2>Plataforma de Questões</h2>
    //       <strong>Prepare-se para o seu concurso na melhor plataforma de questões!</strong>
    //     </div>
    //     <img src={loginImg} alt="imagem de tela de login" />

    //   </div>
    //   <div className='box2'>
    //     <h2>Faça seu cadastro</h2>
    //     <form onSubmit={handleSignUp}>
    //       <label>Nome</label>
    //       <input placeholder='seu nome' value={name} onChange={(e) => setName(e.target.value)} />
    //       <label>Email</label>
    //       <input placeholder='seu email' value={email} onChange={(e) => setEmail(e.target.value)} />
    //       <label>Senha</label>
    //       <input placeholder='sua senha' value={password} onChange={(e) => setPassword(e.target.value)} />
    //       <button type='submit' >
    //         {loadingAuth ? "Carregando..." : "Cadastrar"}
    //       </button>
    //     </form>

    //   </div>

    // </Container>
  )
}